import { jsx as i, jsxs as C } from "react/jsx-runtime";
import { forwardRef as z, useState as T, createRef as G, useRef as J, useCallback as _, useEffect as H, useImperativeHandle as K, createElement as Q } from "react";
import { createPortal as I } from "react-dom";
import { createRoot as U } from "react-dom/client";
import e from "./styles.module.less.js";
import { LoadingSpinner as k } from "./loading-spinner/index.js";
import { useDisableScroll as W } from "../../../utils/use-disable-scroll.js";
const D = z(
  ({
    children: c,
    defaultOpen: b = !1,
    onClose: o,
    onOpen: t,
    className: f = "",
    logo: u = !0,
    titleIcon: g,
    title: p,
    description: $,
    primaryButton: r,
    secondaryPrimaryButton: n,
    secondaryButton: d,
    footerText: w,
    hideCloseButton: R = !1,
    useAuthStyle: L = !1,
    fullscreen: M = !1,
    isSimple: Z = !1,
    blockScroll: s = !1,
    classNames: l,
    closeIcon: S
  }, j) => {
    const [a, x] = T(b), [m, E] = T(!1), F = G(), h = J(null);
    W({ isDisabled: a });
    const V = _(() => {
      h.current && (clearTimeout(h.current), h.current = null), E(!1), x(!0), t == null || t();
    }, [t]), v = _(() => {
      m || (E(!0), h.current = setTimeout(() => {
        x(!1), E(!1), o == null || o();
      }, 200));
    }, [m, o]);
    H(() => () => {
      h.current && clearTimeout(h.current);
    }, []), H(() => {
      s && (a ? document.body.style.overflow = "hidden" : a === !1 && (document.body.style.overflow = "auto"));
    }, [a, s]);
    const q = _(() => {
      d == null || d.onClick(), v();
    }, [d, v]);
    return K(j, () => ({
      openModal: V,
      closeModal: v
    })), a ? Z ? I(
      /* @__PURE__ */ i(
        "div",
        {
          className: `${e.modal} ${f}  ${(l == null ? void 0 : l.container) ?? ""} ${m ? e.closing : ""} ${M ? e.fullscreen : ""}`,
          children: /* @__PURE__ */ C(
            "div",
            {
              className: `${e.modalSimpleContent} ${(l == null ? void 0 : l.content) ?? ""}`,
              children: [
                !R && /* @__PURE__ */ i("div", { className: e.close, onClick: v, children: S ?? /* @__PURE__ */ i(
                  "svg",
                  {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ i(
                      "path",
                      {
                        d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z",
                        fill: "#B0B7BD"
                      }
                    )
                  }
                ) }),
                c
              ]
            }
          )
        }
      ),
      document.body
    ) : I(
      /* @__PURE__ */ i(
        "div",
        {
          className: `${e.modal} ${f ?? ""} ${(l == null ? void 0 : l.container) ?? ""} ${m ? e.closing : ""} ${M ? e.fullscreen : ""}`,
          children: /* @__PURE__ */ C(
            "div",
            {
              ref: F,
              className: `${e.modalContent} ${(l == null ? void 0 : l.content) ?? ""} ${m ? e.closing : ""} ${L ? e.authStyle : ""} ${M ? e.fullscreen : ""}`,
              children: [
                !R && /* @__PURE__ */ i(
                  "div",
                  {
                    className: `${e.close} ${(l == null ? void 0 : l.closeButton) ?? ""}`,
                    onClick: v,
                    children: S ?? /* @__PURE__ */ i(
                      "svg",
                      {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "#B0B7BD",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /* @__PURE__ */ i("path", { d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z" })
                      }
                    )
                  }
                ),
                u && /* @__PURE__ */ i("div", { className: `${e.logo} ${(l == null ? void 0 : l.logo) ?? ""}`, children: /* @__PURE__ */ C(
                  "svg",
                  {
                    width: "48",
                    height: "48",
                    viewBox: "0 0 48 48",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_6687_23096)", children: [
                        /* @__PURE__ */ i(
                          "path",
                          {
                            d: "M24 48C37.2548 48 48 37.2548 48 24H36C36 30.6274 30.6274 36 24 36C17.3726 36 12 30.6274 12 24C12 17.3726 17.3726 12 24 12V0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
                            fill: "#0E5FE3"
                          }
                        ),
                        /* @__PURE__ */ i(
                          "path",
                          {
                            d: "M40 16C44.4183 16 48 12.4183 48 7.99999C48 3.58173 44.4183 0 40 0C35.5817 0 32 3.58173 32 7.99999C32 12.4183 35.5817 16 40 16Z",
                            fill: "#0E5FE3"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_6687_23096", children: /* @__PURE__ */ i("rect", { width: "48", height: "48", fill: "white" }) }) })
                    ]
                  }
                ) }),
                p && /* @__PURE__ */ C("div", { className: e.titleContainer, children: [
                  g && /* @__PURE__ */ i("div", { className: e.titleIcon, children: g }),
                  /* @__PURE__ */ i(
                    "h2",
                    {
                      className: `${e.title} ${L ? e.authStyle : ""}`,
                      dangerouslySetInnerHTML: { __html: p }
                    }
                  )
                ] }),
                $ && /* @__PURE__ */ i(
                  "div",
                  {
                    className: `${e.description} ${(l == null ? void 0 : l.description) ?? ""} ${L ? e.authStyle : ""}`,
                    dangerouslySetInnerHTML: { __html: $ }
                  }
                ),
                c && /* @__PURE__ */ i("div", { className: e.content, children: /* @__PURE__ */ i("div", { className: e.childrenContainer, children: c }) }),
                (r || n || d) && /* @__PURE__ */ C("div", { className: e.buttonContainer, children: [
                  r && /* @__PURE__ */ i(
                    "button",
                    {
                      className: e.primaryButton,
                      onClick: r.onClick,
                      disabled: r.pending || r.disabled,
                      children: r.pending ? /* @__PURE__ */ i(k, {}) : r.label
                    }
                  ),
                  n && /* @__PURE__ */ i(
                    "button",
                    {
                      className: e.primaryButton,
                      onClick: n.onClick,
                      disabled: n.pending || n.disabled,
                      children: n.pending ? /* @__PURE__ */ i(k, {}) : n.label
                    }
                  ),
                  d && /* @__PURE__ */ i(
                    "button",
                    {
                      className: e.secondaryButton,
                      onClick: q,
                      disabled: d.pending || d.disabled,
                      children: d.pending ? /* @__PURE__ */ i(k, {}) : d.label
                    }
                  )
                ] }),
                typeof w == "string" ? /* @__PURE__ */ i(
                  "div",
                  {
                    className: e.footer,
                    dangerouslySetInnerHTML: { __html: w }
                  }
                ) : w
              ]
            }
          )
        }
      ),
      document.body
    ) : null;
  }
);
D.displayName = "Modal";
const N = (c, b = !1) => {
  const o = document.createElement("div");
  document.body.appendChild(o);
  const t = { current: null };
  let f = !1;
  const u = U(o), g = () => {
    f && t.current ? t.current.openModal() : setTimeout(() => g(), 0);
  }, p = () => {
    f && t.current && t.current.closeModal();
  }, $ = () => {
    if (t.current)
      t.current.closeModal(), setTimeout(() => {
        try {
          u.unmount(), document.body.contains(o) && document.body.removeChild(o);
        } catch (n) {
          console.error("Error destroying modal:", n);
        }
      }, 300);
    else
      try {
        u.unmount(), document.body.contains(o) && document.body.removeChild(o);
      } catch (n) {
        console.error("Error destroying modal:", n);
      }
  }, r = Q(D, {
    ...c,
    ref: (n) => {
      n && (t.current = n, f = !0, b && t.current.openModal());
    },
    // Ensure we properly handle the onClose event
    onClose: () => {
      c.onClose && c.onClose();
    }
  });
  return u.render(r), {
    open: g,
    close: p,
    destroy: $
  };
};
export {
  D as Modal,
  N as createModal
};
